import { useEffect } from 'react';
import {
  EntityListProvider,
  useEntityList,
} from '@mainstage/plugin-catalog-react';
import { CatalogTable } from '@agilelab/plugin-wb-builder-catalog';
import {
  KindFilter,
  PracticeShaperFilters,
} from '@agilelab/plugin-wb-practice-shaper';
import {
  WbCardContent,
  UserListPicker as FavouritesPicker,
} from '@agilelab/plugin-wb-platform';
import { Paper } from '@material-ui/core';

const InitializeFilter = (props: { kindList: string[] }) => {
  const { updateFilters } = useEntityList<PracticeShaperFilters>();
  const { kindList } = props;

  useEffect(() => {
    const filters: Partial<PracticeShaperFilters> = {
      kindList: new KindFilter(kindList),
    };
    updateFilters(filters);
  }, [updateFilters, kindList]);

  return null;
};

export const GroupPage = () => {
  return (
    <EntityListProvider pagination={{ limit: 25 }}>
      <Paper>
        <WbCardContent style={{ paddingBottom: 0 }}>
          <InitializeFilter kindList={['group']} />
          <CatalogTable
            preUrl="/platform-settings"
            columnKind="group"
            filtersNode={
              <>
                <FavouritesPicker />
              </>
            }
            limit={25}
          />
        </WbCardContent>
      </Paper>
    </EntityListProvider>
  );
};
